import React, { useCallback, useState } from 'react';

import ROUTES from '@/common/routes';
import { PreventLeaveModal } from '@/modules/core/components';
import { useHistory } from '@/modules/core/hooks';

import { useInvestorById } from '../hooks';

import ManagedWrapper  from './ManagedWrapper';
import PortfolioQuestionnaire from './PortfolioQuestionnaire';
interface Props {
  accountId: string;
  isSwitchMode?: boolean;
  isEmptyPortfolioMode?: boolean;
}
const ManagedSwitchQuestionnaire: React.FC<Props> = ({ isSwitchMode, isEmptyPortfolioMode, accountId }) => {
  const [isPreventLeave, setPreventLeave] = useState(true);
  const { data: investor } = useInvestorById({
    isSwitchMode: true,
  });

  const history = useHistory();
  const handleBack = useCallback(() => {
    if(isSwitchMode) {
      history.push(`${ROUTES.INVESTMENTS}?id=${accountId}`);
    } else {
      history.goBack();
    }
   
  }, [accountId, history, isSwitchMode]);

  const handleNext = useCallback(async () => {
    setPreventLeave(false);
    if (isEmptyPortfolioMode) {
      history.push(ROUTES.MANAGED_SWITCH_EMPTY_FUNDING_AMOUNT(accountId));
    } else {
      history.push(ROUTES.MANAGED_SWITCH_ALLOCATION(accountId));
    }
  }, [accountId, history, isEmptyPortfolioMode]);
  if (!investor.investorId) {
    return null;
  }
  return (
    <ManagedWrapper isSwitchMode={isSwitchMode} isEmptyPortfolioMode={isEmptyPortfolioMode} currentStep={1}>
      
      <PreventLeaveModal isPrevent={isPreventLeave} />
      <PortfolioQuestionnaire isSwitchMode onBack={handleBack} onNext={handleNext} step={1} stepLength={isEmptyPortfolioMode ? 3 : 2} />
    </ManagedWrapper>
  );
};
export default ManagedSwitchQuestionnaire;
